
import { Placement } from '@post-office/placements-frontend/statuspage-edit-spotlight-placement';
export default Placement;
